module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0102.jpg?v=4624fbde";